import Vue from 'vue'
import VueRouter from 'vue-router'

import home from '../views/home/'
import token from '../views/token/' //token详情页面
import address from '../views/address/' //address页面
import transaction from '../views/transaction/' //transaction页面
import block from '../views/block/' //block页面
import account from '../views/account/' //account页面
import ercSevenToken from '../views/token/erc_Seven_token' //721Token页面
import transDetail from '../views/transaction/detail' //trans Detail页面
import blockDetail from '../views/block/detail' //block Detail页面
import accountContract from '../views/account/contract' //account Contract页面
import tokenErc from '../views/token/erc_two_token' //Token Erc20 Tokens页面
import transferErc from '../views/token/erc_two_transfer' //Token Erc20 Tokens页面
import transSevenErc from '../views/token/erc_seven_transfer' //Token Erc20 Tokens页面
import tokenTransfer from '../views/token/transfer' //Token Transfer页面
import tokenHolders from '../views/token/holders' //Token Holders页面
import tokenInventory from '../views/token/inventory' //Token Inventory页面
import AccountInternal from '../views/Internal/index' //Account Inernal Txns页面
import accountToken from '../views/address/Token' //721Token NFT页面
import Nft from '../views/token/Nft' //Account NFT页面
import validator from '../views/validator/index' //Validators 页面
import validatorDetail from '../views/validator/detail' //Validators Detail页面
import voterDetail from '../views/validator/voter_detail' //Validators voter-Detail页面

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    component: home,
    meta: {
      keep_alive: true,
    },
  },
  {
    path: "/token/:number",
    component: token,
  },
  {
    path: "/address/:number",
    component: address,
  },
  {
    path: "/address/:number",
    component: address,
  },
  {
    path: "/transaction",
    component: transaction,
  },
  {
    path: "/transaction/:number",
    component: transaction,
  },
  {
    path: "/block",
    component: block,
  },
  {
    path: "/block/:number",
    component: blockDetail,
  },
  {
    path: "/account",
    component: account,
  },
  {
    path: "/tx/:hash",
    component: transDetail,
  },
  {
    path: "/blockDetail",
    component: blockDetail,
  },
  {
    path: "/verifiedContracts",
    component: accountContract,
  },
  {
    path: "/mrc20tokens",//ercToken
    component: tokenErc,
  },
  {
    path: "/mrc20transfers",//transferErc
    component: transferErc,
  },
  {
    path: "/mrc20transfers/:number",
    component: transferErc,
  },
  {
    path: "/mrc721tokens", //ercSevenToken
    component: ercSevenToken,
  },
  {
    path: "/mrc721transfers",//transSevenErc
    component: transSevenErc,
  },
  {
    path: "/mrc721transfers/:number",
    component: transSevenErc,
  },
  {
    path: "/tokenTrans/:number",
    component: tokenTransfer,
  },
  {
    path: "/tokenHolders/:number",
    component: tokenHolders,
  },
  {
    path: "/tokenInventory/:number",
    component: tokenInventory,
  },
  {
    path: "/accountInternal/:number",
    component: AccountInternal,
  },
  {
    path: "/accountToken/:number",
    component: accountToken,
  },
  {
    path: "/nft/:number",
    component: Nft,
  },
  {
    path: "/validators",
    component: validator,
  },
  {
    path: "/validators/:number",
    component: validatorDetail,
  },
  {
    path: "/voter/:number",
    component: voterDetail,
  },



  // {
  //   path: "/about",
  //   name: "About",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/About.vue"),
  // },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    // to, from, savedPosition
    return {x: 0, y: 0}
  },
});

export default router
